import { useState } from "react";

const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "music", label: "Music" },
  { id: "contact", label: "Contact" },
];

export function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <a href="#home" className="nav-brand" onClick={closeMenu}>
        CASCADE
      </a>
      <button
        type="button"
        className={`nav-toggle ${menuOpen ? "open" : ""}`}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
      </button>
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        {NAV_LINKS.map(({ id, label }) => (
          <li key={id}>
            <a href={`#${id}`} onClick={closeMenu}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
